export const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const AWS_REGION = process.env.REACT_APP_AWS_REGION;
export const SIGNOUT_URI =
  process.env.REACT_APP_COGNITO_URL +
  "/logout?response_type=code&client_id=" +
  CLIENT_ID;
export const SIGN_IN_URI = window.location.origin + "/loginCallback";
export const ADMIN_GROUP_NAME = "csol-11931-outcomes-based-buying-admins";
export const USER_GROUP_NAME = "csol-11931-outcomes-based-buying-users-group";
export const FILE_UPLOAD_API_ENDPOINT =
  process.env.REACT_APP_FILE_UPLOAD_API_GATEWAY_ENDPOINT;
export const DASHBOARD_API_ENDPOINT = process.env.REACT_APP_DASHBOARD_ENDPOINT;
export const BUCKET = process.env.REACT_APP_BUCKET;


export const USER_GROUP_PREFIX = "csol-11931-users-group-";
export const USER_GROUPS = [
  {
    GroupName: "csol-11931-users-group-lwwuxub_q6ldg3t",
    Display: "Dentsu Canada Partners",
  },
  {
    GroupName: "csol-11931-users-group-bjvqtx2_os2jeg4_53dm56l",
    Display: "Apex Germany Partners",
  },
  {
    GroupName:
      "csol-11931-users-group-39h6v3h_7sj2r47_8id7nty_hg2weke_hs50qpd_i9mclns_ju4h0hu_ojtfrcu_siql7bd",
    Display: "Dentsu Germany Partners",
  },
  {
    GroupName:
      "csol-11931-users-group-demo",
    Display: "Demo Partner",
  },
  {
    GroupName:
      "csol-11931-users-group-qfxb3co",
    Display: "Havas Switzerland",
  },
{
  GroupName:
    "csol-11931-users-group-vko50on",
    Display: "WPP Media Solutions Germany",
  },
{
  GroupName:
    "csol-11931-users-group-gq7kyh3",
    Display: "MPX GmbH Germany",
  }
];